<template>
  <dv-border-box-9>
    <h2 class="title">采集实时数据量</h2>
    <div ref="lineBarChart" style="width: 600px; height: 300px"></div>
  </dv-border-box-9>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  name: 'QualityChartPerson',
  data() {
    return {
      lineBarOption: {
        color: ['#2499F8', '#FF9900'],
        grid: {
          left: 25,
          top: 50,
          bottom: 20,
          right: 25,
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['月总数'],
          top: 10,
          textStyle: {
            color: '#96BBDA',
            fontWeight: 'bold',
          },
        },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisLine: {
            lineStyle: {
              color: '#0091F2',
            },
          },
          axisLabel: {
            color: '#96BBDA',
            fontWeight: 'bold',
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#0091F2',
            },
          },
          axisLabel: {
            color: '#96BBDA',
            fontWeight: 'bold',
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#0091F2',
            },
          },
        },
        series: [
          {
            name: '月总数',
            data: [2200, 2900, 3680, 2200, 2900, 3680, 2200, 2900, 3680, 2200, 2900, 3680],
            type: 'bar',
            barWidth: 20,
          },
        ],
      },
      url: {
        monthData: '/show/bigScreen/getDeviceDataByMonth',
      },
      projectId: null,
    }
  },
  async mounted() {},
  methods: {
    // 重新加载数据
    reloadData(projectId) {
      this.projectId = projectId
      this.loadData()
    },
    // 加载数据
    async loadData() {
      if (!this.projectId) {
        return
      }
      const result = await this.getDataByMonth()
      const { monthData } = result.result
      this.setRenderChartData(monthData, this.lineBarOption)
      const lineBarChart = this.$echarts.init(this.$refs.lineBarChart)
      lineBarChart.setOption(this.lineBarOption)
    },
    /**
     * @description: 获取服务数据
     * @param {undefined}
     * @return {promise}
     */
    async getDataByMonth() {
      // 171
      return await getAction(this.url.monthData + '?projectId=' + this.projectId)
    },
    /**
     * @description: 设置图表渲染数据
     * @param {list: Array, op: Object}
     * @return {undefined}
     */
    setRenderChartData(list, op) {
      const xData = [],
        sData = []
      list.forEach((item) => {
        xData.push(item.fdate)
        sData.push(item.total)
      })
      op.xAxis.data = xData
      op.series[0].data = sData
    },
  },
}
</script>

<style lang='less' scoped>
.title {
  text-align: center;
  margin: 0;
  // margin-bottom: 24px;
  padding-top: 18px;
  color: #96bbda;
  font-size: 24px;
  font-weight: 500;
}
.border-box-content {
  padding: 24px;
}
</style>
